import { render, staticRenderFns } from "./ProjectReportsTableItem.vue?vue&type=template&id=1dae3c6c&scoped=true&"
import script from "./ProjectReportsTableItem.vue?vue&type=script&lang=js&"
export * from "./ProjectReportsTableItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReportsTableItem.vue?vue&type=style&index=0&id=1dae3c6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae3c6c",
  null
  
)

export default component.exports